/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./index.1.vue?vue&type=template&id=3237cb34&scoped=true"
import script from "./index.1.vue?vue&type=script&lang=js"
export * from "./index.1.vue?vue&type=script&lang=js"
import style0 from "./index.1.vue?vue&type=style&index=0&id=3237cb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3237cb34",
  null
  
)

export default component.exports